import { TenantEventType, TenantRow, TenantStorage } from "services/api/tenants/types";
import { ButtonMenu } from "ui/components/Button/ButtonMenu";
import ButtonMenuItem from "ui/components/Button/ButtonMenu/ButtonMenuItem";
import TableIcon from "ui/components/Table/TableSearch/components/TableIcon";
import Badge from "ui/components/Badge/Badge";
import { Column, ColumnTypes } from "ui/components/Table/TableSearch/types";
import { formatFileSize } from "helpers";

const getTenantName = (row: TenantRow): string =>
  row.name ||
  row.companyName ||
  [row.firstName, row.lastName].filter(Boolean).join(" ");

const getInitials = (name: string): string =>
  name
    .split(" ")
    .slice(0, 2)
    .map((word) => word.charAt(0).toUpperCase())
    .join("");

export const SETTING_TENANTS_SEARCH_COLUMNS = (
  storageByTenant: Record<string, TenantStorage> = {}
): Column[] => [
  {
    title: "",
    field: "",
    type: ColumnTypes.custom,
    render: (row: TenantRow) => <TableIcon initials={getInitials(getTenantName(row))} />,
  },
  {
    title: "Naziv",
    field: "",
    type: ColumnTypes.custom,
    render: (row: TenantRow) => <>{getTenantName(row)}</>,
  },
  {
    title: "Tip",
    field: "",
    type: ColumnTypes.custom,
    render: (row: TenantRow) => {
      if (!row.tenantType?.name) return <></>;
      const isCompany = row.tenantType?.id === "C";
      return (
        <Badge
          text={row.tenantType.name}
          variant={isCompany ? "info" : "success"}
          height="small"
        />
      );
    },
  },
  {
    title: "Email",
    field: "",
    type: ColumnTypes.custom,
    render: (row: TenantRow) => {
      return <>{row.email ?? ""}</>;
    },
  },
  {
    title: "OIB",
    field: "",
    type: ColumnTypes.custom,
    render: (row: TenantRow) => {
      return <>{row.personalIdentificationNumber ?? ""}</>;
    },
  },
  {
    title: "Storage",
    field: "",
    type: ColumnTypes.custom,
    render: (row: TenantRow) => {
      const s = storageByTenant[row.id];
      if (!s) return <span className="text-slate-400">—</span>;
      return (
        <div className="whitespace-nowrap">
          <span className="font-medium text-slate-800">{formatFileSize(s.activeKb)}</span>
          <span className="text-slate-400 text-xs"> / {formatFileSize(s.totalKb)} na disku</span>
        </div>
      );
    },
  },
  {
    title: "",
    field: "type",
    type: ColumnTypes.custom,
    render: (row, onEventClick) => {
      return (
        <ButtonMenu endIcon="/media/icons/more-dots.svg" variant="text">
          <ButtonMenuItem
            startIcon="/media/icons/edit.svg"
            onClick={() => onEventClick(row.id, TenantEventType.DETAIL)}
          >
            Detalji tenanta
          </ButtonMenuItem>
        </ButtonMenu>
      );
    },
  },
];
